import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AdminLayout from './components/AdminLayout';
import Dashboard from './pages/Dashboard';
import Products from './pages/Products';
import ProductForm from './pages/ProductForm';
import Categories from './pages/Categories';
import CategoryForm from './pages/CategoryForm';
import Blogs from './pages/Blogs';
import BlogForm from './pages/BlogForm';
import Advertisements from './pages/Advertisements';
import './App.css';

// Composant principal de l'application admin
const AdminApp = () => {
  return (
    <div className="admin-app">
      <Routes>
        {/* Redirection par défaut vers /admin/dashboard */}
        <Route index element={<Navigate to="dashboard" replace />} />

        {/* Routes protégées relatives à /admin */}
        <Route
          path="dashboard"
          element={
            <AdminLayout>
              <Dashboard />
            </AdminLayout>
          }
        />

        {/* Routes des produits */}
        <Route
          path="products"
          element={
            <AdminLayout>
              <Products />
            </AdminLayout>
          }
        />
        <Route
          path="products/new"
          element={
            <AdminLayout>
              <ProductForm />
            </AdminLayout>
          }
        />
        <Route
          path="products/:id/edit"
          element={
            <AdminLayout>
              <ProductForm />
            </AdminLayout>
          }
        />

        {/* Routes des catégories */}
        <Route
          path="categories"
          element={
            <AdminLayout>
              <Categories />
            </AdminLayout>
          }
        />
        <Route
          path="categories/new"
          element={
            <AdminLayout>
              <CategoryForm />
            </AdminLayout>
          }
        />
        <Route
          path="categories/:id/edit"
          element={
            <AdminLayout>
              <CategoryForm />
            </AdminLayout>
          }
        />

        {/* Routes des blogs */}
        <Route
          path="blogs"
          element={
            <AdminLayout>
              <Blogs />
            </AdminLayout>
          }
        />
        <Route
          path="blogs/new"
          element={
            <AdminLayout>
              <BlogForm />
            </AdminLayout>
          }
        />
        <Route
          path="blogs/:id/edit"
          element={
            <AdminLayout>
              <BlogForm />
            </AdminLayout>
          }
        />

        {/* Routes des publicités */}
        <Route
          path="advertisements"
          element={
            <AdminLayout>
              <Advertisements />
            </AdminLayout>
          }
        />

        {/* Catch-all sous /admin → dashboard */}
        <Route path="*" element={<Navigate to="dashboard" replace />} />
      </Routes>
    </div>
  );
};

export default AdminApp;
